import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/admin');

const AdminFxs = {
    deleteUserFx: domain.effect(api.admin.deleteUser),
    generateDocumentFx: domain.effect(api.admin.generateDocument),
    getQInstancesFx: domain.effect(api.admin.getQInstances),
};

export default AdminFxs;
